import { type MenuResponse } from '@on3/api';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import { Link } from '@on3/ui-lib/components/Link';
import { useSite } from '@on3/ui-lib/index';

import styles from './QuickLinks.module.scss';

export const QuickLinks = ({
  title = 'Quick Links',
  quickLinks,
}: {
  title?: string;
  quickLinks: MenuResponse[];
}) => {
  const { currentSite: site } = useSite();
  const isTeamSite = site.isTeam;

  return (
    <section className={styles.block}>
      <h2 className={styles.title}>{title}</h2>
      <ul>
        {quickLinks.map((link) => (
          <li className={styles.row} key={link.id}>
            <Link
              className={styles.link}
              href={link.url}
              title={link.title || ''}
            >
              {isTeamSite && (
                <Avatar
                  altText={site.organization?.knownAs || ''}
                  domain={site.organization?.defaultAssetRes?.domain}
                  height={25}
                  source={site.organization?.defaultAssetRes?.source}
                  width={25}
                />
              )}
              {link.title}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
